import React, { Component } from "react";

const countryList = [
  "AT",
  "BE",
  "HR",
  "BG",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
];

class SubscriptionOverview extends Component {
  formatMoney(number, decPlaces, decSep, thouSep) {
    (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
      (decSep = typeof decSep === "undefined" ? "." : decSep);
    thouSep = typeof thouSep === "undefined" ? "," : thouSep;
    let sign = number < 0 ? "-" : "";
    let i = String(
      parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
    );
    let j = (j = i.length) > 3 ? j % 3 : 0;

    return (
      sign +
      (j ? i.substr(0, j) + thouSep : "") +
      i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      (decPlaces
        ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
        : "")
    );
  }

  render() {
    const { accountPackage, paymentInterval } = this.props;

    let vat = false;
    if (this.props.form.country === "NL") {
      vat = true;
    }
    if (
      countryList.includes(this.props.form.country) &&
      (this.props.form.tax_number === "" || !this.props.form.tax_number)
    ) {
      vat = true;
    }

    let price = 0;
    if (accountPackage === "small" && paymentInterval === "month") {
      price = 145;
    }
    if (accountPackage === "medium" && paymentInterval === "month") {
      price = 320;
    }
    if (accountPackage === "large" && paymentInterval === "month") {
      price = 580;
    }
    if (accountPackage === "small" && paymentInterval === "year") {
      price = 1572;
    }
    if (accountPackage === "medium" && paymentInterval === "year") {
      price = 3456;
    }
    if (accountPackage === "large" && paymentInterval === "year") {
      price = 6264;
    }

    const totalPrice = vat ? price * 1.21 : price;

    return (
      <div className="aboss__signup-agency-form-table">
        <h1 style={{ marginTop: "50px" }}>Subscription Overview</h1>
        <table>
          <thead>
            <tr>
              <td>Description</td>
              <td>Amount</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>ABOSS Agency {accountPackage}</strong>
                <br />
                <span>
                  Charged on a {paymentInterval}ly basis
                  {this.props.form.coupon_code === "2020trial" &&
                    paymentInterval === "month" && (
                      <strong>, billed after the first free month</strong>
                    )}
                </span>
              </td>
              <td>€ {this.formatMoney(price)}</td>
            </tr>
            <tr>
              <td style={{ textAlign: "right" }}>
                <strong>VAT {vat ? "21%" : "0%"}</strong>
              </td>
              {vat && <td>€ {this.formatMoney((totalPrice / 121) * 21)}</td>}
              {!vat && <td>€ 0.00</td>}
            </tr>
            <tr>
              <td style={{ textAlign: "right" }}>
                <strong>Total</strong>
              </td>
              <td>€ {this.formatMoney(totalPrice)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default SubscriptionOverview;



// WEBPACK FOOTER //
// src/views/sign-up-agency/subscription-overview.js